import React, { useState } from 'react';
import { LinearProgress, Button } from "@mui/material";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

export default function UploadImage({ onImageSelect }) {
    const [isUploading, setIsUploading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);

    return (
        <div style={{ marginBottom: '10px' }}>
            <input
                accept="image/*"
                style={{ display: 'none' }}
                id="raised-button-file"
                type="file"
                onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                        const reader = new FileReader();
                        reader.onloadstart = () => {
                            setIsUploading(true);
                        };
                        reader.onprogress = (event) => {
                            const progress = (event.loaded / event.total) * 100;
                            setUploadProgress(progress);
                        };
                        reader.onload = () => {
                            onImageSelect(reader.result);
                            setIsUploading(false);
                        };
                        reader.readAsDataURL(file);
                    }
                }}
            />
            <label htmlFor="raised-button-file">
                <Button fullWidth variant="contained" component="span" endIcon={<CloudUploadIcon />}>
                    Upload Image
                </Button>
            </label>
            {isUploading && (
                <LinearProgress variant="determinate" value={uploadProgress} style={{ marginTop: '10px' }} />
            )}
        </div>
    )
}
